import gql from 'graphql-tag';
import { useQuery, useResult } from '@vue/apollo-composable';

interface ServiceApiInput {
    service?: string;
    type?: string;
    path?: string;
    body?: any;
    params?: any;
}

const VERIFY_TRACK_CODE_QUERY = gql`
    query otherServiceApi($where: ServiceApiInput!) {
        otherServiceApi(where: $where)
    }
`;

// 校验是否埋码
export function useOtherServiceApi(params: ServiceApiInput) {
    const {
        result,
        onResult: onOtherServiceApiResult,
        onError: onOtherServiceApiError
    } = useQuery<{ otherServiceApi: any }>(
        VERIFY_TRACK_CODE_QUERY,
        {
            where: {
                ...params
            }
        },
        {
            fetchPolicy: 'no-cache'
        }
    );
    const otherServiceApiResult = useResult(result, null, data => {
        return data?.otherServiceApi?.hasTrackCode?.hasCode;
    });

    return {
        otherServiceApiResult,
        onOtherServiceApiResult,
        onOtherServiceApiError
    };
}
